import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatRippleModule } from '@angular/material/core';
import { RideStatusChipComponent } from './ride-status-chip.component';

@NgModule({
  declarations: [RideStatusChipComponent],
  imports: [CommonModule, MatButtonModule, MatRippleModule, MatChipsModule],
  exports: [RideStatusChipComponent]
})
export class RideStatusChipModule {}
